import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-remove",
  "use": "icon-remove-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-remove\"><defs><style type=\"text/css\"></style></defs><path d=\"M746.58 182.614H278.703c-43.075 0-77.98 34.901-77.98 77.976v25.993h623.834V260.59c0-43.075-34.902-77.976-77.979-77.976M610.37 130.63l11.474 82.037H403.441l11.472-82.037H610.37m6.245-51.984H408.67c-21.45 0-41.4 17.362-44.396 38.632l-15.205 108.767c-2.97 21.244 12.16 38.607 33.609 38.607h259.93c21.448 0 36.579-17.362 33.583-38.633l-15.205-108.766c-2.973-21.245-22.923-38.607-44.371-38.607m142.96 259.92H265.707c-28.582 0-49.88 23.302-47.29 51.78l42.595 468.262c2.563 28.48 28.1 51.781 56.682 51.781H707.59c28.582 0 54.118-23.302 56.683-51.78l42.594-468.262c2.588-28.48-18.71-51.781-47.292-51.781M408.67 806.42h-77.98l-25.993-363.887h103.972V806.42z m155.958 0H460.656V442.534h103.972V806.42z m129.965 0h-77.98V442.534h103.973L694.593 806.42z\" p-id=\"10429\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/remove.svg
// module id = VFDz
// module chunks = 45